import type { BaseDocument } from '../mongo/base-document.interface';
import { ObjectFactory } from './object.factory';

let counter = 0;

export class BaseDocumentFactory extends ObjectFactory<BaseDocument> {
  protected getDefaults(): BaseDocument {
    counter += 1;
    return {
      createdAt: new Date('2026-01-01T00:00:00.000Z'),
      deletedAt: null,
      id: `test-id-${counter}`,
      tenantId: 'aaaa00001111bbbb2222cccc',
      updatedAt: new Date('2026-01-01T00:00:00.000Z'),
    };
  }
}

/** Pre-instantiated for convenience — most tests just import this. */
export const baseDocumentFactory = new BaseDocumentFactory();
